var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-sm font-semibold font-strict text-center mb-4" },
    [
      _vm.canceled
        ? _c("p", { staticClass: "flex flex-col text-red-600" }, [
            _c("span", { staticClass: "font-medium text-xs" }, [
              _vm._v(" You can continue using "),
              _c("br"),
              _vm._v(" the app until " + _vm._s(_vm.paymentPeriod) + " "),
            ]),
          ])
        : _vm._t("default", function () {
            return [
              _c("p", [
                _vm._v(" Next invoice on "),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.paymentPeriod) + ". "),
              ]),
            ]
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }